var manufacturers, models, diagrams, parts, modalWidth, mobile;

var searchLoader = `<div class="search-loading">
  					<div></div>
  					<div></div>
  					<div></div>
				</div>`;


if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $(`
        <a href="#" class="button button--primary parts-search" style='width: 100%;display:flex; align-items:center;justify-content:center'>
        <svg style="margin-right:10px" width="21" height="26" viewBox="0 0 21 26" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 12.3535H12.8333C12.5019 12.3539 12.1842 12.4857 11.9498 12.72C11.7155 12.9544 11.5837 13.2721 11.5833 13.6035V14.0202H10.3737L8.60972 13.6673C8.53416 13.4091 8.37717 13.1823 8.16217 13.0206C7.94716 12.859 7.68567 12.7711 7.41667 12.7702H0.75V13.6035H7.41667C7.52714 13.6036 7.63306 13.6476 7.71117 13.7257C7.78929 13.8038 7.83322 13.9097 7.83333 14.0202V16.5202C7.83322 16.6307 7.78929 16.7366 7.71117 16.8147C7.63306 16.8928 7.52714 16.9367 7.41667 16.9368H0.75V17.7702H7.41667C7.68567 17.7693 7.94716 17.6814 8.16217 17.5197C8.37717 17.3581 8.53416 17.1312 8.60972 16.8731L10.3737 16.5202H11.5833V17.3535C11.5837 17.6849 11.7155 18.0027 11.9498 18.237C12.1842 18.4713 12.5019 18.6032 12.8333 18.6035H19.5C19.8314 18.6032 20.1491 18.4713 20.3835 18.237C20.6178 18.0027 20.7496 17.6849 20.75 17.3535V13.6035C20.7496 13.2721 20.6178 12.9544 20.3835 12.72C20.1491 12.4857 19.8314 12.3539 19.5 12.3535V12.3535ZM8.66667 14.5284L9.91667 14.7782V15.7621L8.66667 16.012V14.5284ZM10.75 15.6868V14.8535H11.5833V15.6868H10.75ZM19.9167 17.3535C19.9166 17.464 19.8726 17.5699 19.7945 17.648C19.7164 17.7261 19.6105 17.7701 19.5 17.7702H12.8333C12.7229 17.7701 12.6169 17.7261 12.5388 17.648C12.4607 17.5699 12.4168 17.464 12.4167 17.3535V14.8535H19.9167V17.3535ZM12.4167 14.0202V13.6035C12.4168 13.493 12.4607 13.3871 12.5388 13.309C12.6169 13.2309 12.7229 13.187 12.8333 13.1868H19.5C19.6105 13.187 19.7164 13.2309 19.7945 13.309C19.8726 13.3871 19.9166 13.493 19.9167 13.6035V14.0202H12.4167Z" fill="#ffffff"></path>
            <path d="M12.8333 11.5208H19.5C19.7209 11.5206 19.9328 11.4327 20.089 11.2765C20.2452 11.1203 20.3331 10.9084 20.3333 10.6875V9.02083C20.3331 8.7999 20.2452 8.58808 20.089 8.43186C19.9328 8.27563 19.7209 8.18775 19.5 8.1875H19.2761L18.1316 6.84106C18.0841 6.76137 18.0644 6.66811 18.0758 6.57601C18.0871 6.48391 18.1288 6.39821 18.1943 6.33244L18.4242 6.10254C18.6338 5.89401 18.7999 5.646 18.9131 5.37285C19.0262 5.09969 19.0841 4.80681 19.0833 4.51115V3.60417C19.0833 2.83062 18.776 2.08875 18.2291 1.54177C17.6821 0.994791 16.9402 0.6875 16.1667 0.6875C15.3931 0.6875 14.6513 0.994791 14.1043 1.54177C13.5573 2.08875 13.25 2.83062 13.25 3.60417V4.51115C13.2492 4.80681 13.3071 5.09969 13.4202 5.37285C13.5334 5.646 13.6996 5.89401 13.9092 6.10254L14.1391 6.33244C14.2045 6.39821 14.2462 6.48391 14.2576 6.57601C14.2689 6.66811 14.2493 6.76137 14.2017 6.84106L13.0573 8.1875H12.8333C12.6124 8.18775 12.4006 8.27563 12.2444 8.43186C12.0881 8.58808 12.0003 8.7999 12 9.02083V10.6875C12.0003 10.9084 12.0881 11.1203 12.2444 11.2765C12.4006 11.4327 12.6124 11.5206 12.8333 11.5208V11.5208ZM19.5 10.6875H12.8333V9.02083H19.5V10.6875ZM14.855 7.35905L14.8843 7.3204C15.044 7.07979 15.1157 6.7914 15.0873 6.50402C15.0588 6.21664 14.932 5.94789 14.7282 5.74325L14.4984 5.51335C14.3664 5.382 14.2618 5.22581 14.1905 5.05379C14.1193 4.88177 14.0829 4.69734 14.0833 4.51115V3.60417C14.0833 3.05163 14.3028 2.52173 14.6935 2.13103C15.0842 1.74033 15.6141 1.52083 16.1667 1.52083C16.7192 1.52083 17.2491 1.74033 17.6398 2.13103C18.0305 2.52173 18.25 3.05163 18.25 3.60417V4.51115C18.2505 4.69734 18.214 4.88177 18.1428 5.05379C18.0716 5.22581 17.9669 5.382 17.835 5.51335L17.6051 5.74325C17.4013 5.94789 17.2745 6.21664 17.2461 6.50402C17.2176 6.7914 17.2893 7.07979 17.449 7.3204L18.1822 8.1875H14.1511L14.855 7.35905Z" fill="#ffffff"></path>
            <path d="M16.1668 19.5371L15.824 20.0335C15.5333 20.4543 14.0835 22.6039 14.0835 23.6037C14.0835 24.1562 14.303 24.6861 14.6937 25.0768C15.0844 25.4675 15.6143 25.687 16.1668 25.687C16.7194 25.687 17.2493 25.4675 17.64 25.0768C18.0307 24.6861 18.2502 24.1562 18.2502 23.6037C18.2502 22.6039 16.8004 20.4543 16.5096 20.0335L16.1668 19.5371ZM16.1668 24.8537C15.8354 24.8533 15.5177 24.7215 15.2833 24.4872C15.049 24.2528 14.9172 23.9351 14.9168 23.6037C14.9168 23.1488 15.5672 21.961 16.1668 21.0235C16.7666 21.9606 17.4168 23.148 17.4168 23.6037C17.4165 23.9351 17.2847 24.2528 17.0503 24.4872C16.816 24.7215 16.4982 24.8533 16.1668 24.8537V24.8537Z" fill="#ffffff"></path>
        </svg>
        <span>BROWSE PARTS</span>
        </a>   
`).insertAfter(".shopify-section__header");

    mobile = true
}

//Activate parts search
$(".parts-search").on('click touch', function (e) {


    if (typeof searchable_brands !== 'undefined') {

        $("swal2-html-container").focus();

        manufacturers = searchLoader + `<div class="search-heading"><h2>TOP BRANDS</h2></div>`;

        e.preventDefault();
        searchable_brands.sort((a, b) => (a.name > b.name) ? 1 : -1)

        $.each(searchable_brands, function (index, brand) {

            var id = brand.id;
            var name = brand.name;
            var image = `https://parts.espressoparts.com/images/brands/${id}.jpg`;

            manufacturers = manufacturers + `<div data-id="${id}" class="col-search brand-search"><img src="${image}" alt="${name}"></div>`;
        });

        let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (mobile) {

            $('html, body').css({
                overflow: 'hidden',
                height: '100%'
            });

            modalWidth = screenWidth - 30;
        } else if (screenWidth > 1000) {

            modalWidth = 980;
        } else {

            modalWidth = screenWidth - 20;
        }


        Swal.fire({

            showConfirmButton: false,
            html: manufacturers,
            position: 'top',
            showClass: {
                backdrop: 'swal2-noanimation', // disable backdrop animation
                popup: '',                     // disable popup animation
                icon: ''                       // disable icon animation
            },
            hideClass: {
                popup: '',                     // disable popup fade-out animation
            },
            width: modalWidth,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCloseButton: true,
            didClose: () => {
                $(".swal2-html-container").html('');
                $('html, body').css({
                    overflow: 'auto',
                    height: 'auto'
                });
            }
        });
    }
});

//Get models by manufacturer id
$(document).on("click touch", ".brand-search", function () {

    showLoading();
    var id = $(this).data("id");
    models = `<div id="pManufacturers" class="previous-holder"><span class="previous ">&#8249;</span></div>${searchLoader}`;

    $.get(`https://parts.espressoparts.com/api/manufacturer/${id}`, function (response) {


        //If brand has models
        if (Object.keys(response.models).length) {

            models = models + `<div class="search-heading"><img src="https://parts.espressoparts.com/images/brands/${response.manufacturer_id}.jpg" alt="${response.manufacturer_name}"><h3>Models</h3></div>`;

            $.each(response.models, function (id, brand) {

                var image = `https://parts.espressoparts.com/images/models/${id}.jpg`;
                models = models + `<div data-id="${id}" class="col-search model-search"><img src="${image}" alt="${brand}"><p>${brand}</p></div>`;
            });
        } else {

            models = models + `<div class="search-heading"><img src="https://parts.espressoparts.com/images/brands/${response.manufacturer_id}.jpg" alt="${response.manufacturer_name}"><h3>Parts</h3></div>`;

            $.each(response.categories, function (id, category) {

                models = models + `<div data-manufacturer="${response.manufacturer_id}" data-category="${id}" class="col-search manufacturer-category-search"><span class="search-link">${category}</span></div>`;
            });
        }

        $(".swal2-html-container").html('').html(models);
    });

});

$(document).on("click", '#pManufacturers', function () {

    $(".swal2-html-container").html('').html(manufacturers);
});

//Get Diagrams by model id
$(document).on("click touch", ".model-search", function () {

    showLoading();
    var id = $(this).data("id");
    diagrams = `<div id="pModels" class="previous-holder"><span class="previous ">&#8249;</span></div>${searchLoader}`;

    $.get(`https://parts.espressoparts.com/api/model/${id}`, function (response) {

        let marginTop = 0;

        if (mobile) {

            marginTop = '60px';
        }

        diagrams = diagrams + `<div class="search-heading">
                                    <h2 style="margin-top:${marginTop}">${response.manufacturer.name} ${response.model.name}</h2>
                                    <img src="https://parts.espressoparts.com/images/models/${response.model.id}.jpg" alt="${response.model.name}">
                               </div>`;

        diagrams = diagrams + `<div class="search-row">`;

        if (Object.keys(response.diagrams).length) {

            if (!mobile) {
                diagrams = diagrams + `<div class="search-row"><div class="search-heading"><h3>Diagrams</h3></div>`;

                $.each(response.diagrams, function (id, diagram) {

                    var image = `https://parts.espressoparts.com/images/diagrams/${id}.jpg`;
                    diagrams = diagrams + `<div data-diagram="${diagram}" data-id="${id}" class="col-search diagram-search"><img src="${image}" alt="${diagram}"><p>${diagram}</p></div>`;
                });
            }
        }

        diagrams = diagrams + `</div><div class="search-row"><div class="search-heading"><h3>Part Categories</h3></div>
                               <div data-model="${response.model.id}" data-category="0" class="col-search model-category-search"><span class="search-link">ALL PARTS</span></div>
        `;

        $.each(response.categories, function (id, category) {

            diagrams = diagrams + `<div data-model="${response.model.id}" data-category="${id}" class="col-search model-category-search"><span class="search-link">${category}</span></div>`;
        });

        diagrams = diagrams + `</div>`;

        $(".swal2-html-container").html('').html(diagrams);
    });
});

$(document).on("click", '#pModels', function () {

    $(".swal2-html-container").html('').html(models);
});


//Get category parts by manufacturer id and category id
$(document).on("click touch", ".manufacturer-category-search", function () {

    showLoading();
    var manufacturer_id = $(this).data("manufacturer");
    var category_id = $(this).data("category");

    $.get(`https://parts.espressoparts.com/api/manufacturer/${manufacturer_id}/category/${category_id}`, function (response) {

        parts = `<div id="pManufacturers" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>${response.manufacturer}</h2>
                                    <h3>Category: ${response.category}</h3>
                               </div>`;


        $.each(response.parts, function (id, part) {

            if (part.shopify_product_id) {
                var url = `https://parts.espressoparts.com/shopify-id/${part.shopify_product_id}`;
                parts = parts + `<a target="_blank" href="${url}"><div class="parts-holder"><img onerror="imgError(this);" src="https://parts.espressoparts.com/images/parts/${part.id}.jpg" alt="${response.manufacturer}"><span class="search-link">${part.shopify_title} - (SKU: ${part.sku})</span></div></a>`;
            }
        });

        $(".swal2-html-container").html('').html(parts);
    });
})


//Get category parts by model id and category id
$(document).on("click touch", ".model-category-search", function () {

    showLoading();
    var model_id = $(this).data("model");
    var category_id = $(this).data("category");

    $.get(`https://parts.espressoparts.com/api/model/${model_id}/category/${category_id}`, function (response) {

        parts = `<div id="pDiagrams" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>${response.manufacturer} ${response.model}</h2>
                                    <img src="https://parts.espressoparts.com/images/models/${response.model_id}.jpg" alt="${response.model}">
                                    <h3>Category: ${response.category}</h3>
                               </div>`;


        $.each(response.parts, function (id, part) {

            if (part.shopify_product_id) {
                var url = `https://parts.espressoparts.com/shopify-id/${part.shopify_product_id}`;
                parts = parts + `<a target="_blank" href="${url}"><div class="parts-holder"><img onerror="imgError(this);" src="https://parts.espressoparts.com/images/parts/${part.id}.jpg" alt="${response.model}"><span class="search-link">${part.shopify_title} - (SKU: ${part.sku})</span></div></a>`;
            }
        });

        $(".swal2-html-container").html('').html(parts);
    });
})

$(document).on("click", '#pDiagrams', function () {

    $(".swal2-html-container").html('').html(diagrams);
});


//Open Diagram by diagram id
$(document).on("click touch", ".diagram-search", function () {

    showLoading();
    var diagramId = $(this).data("id");

    var html = `<div id="pParts" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="web-annotation"><img id ="diagram" src="https://parts.espressoparts.com/images/diagrams/${diagramId}.jpg" alt="" style="width:100vw" class="diagram-border"></div>`;
    $(".swal2-html-container").html('').html(html);

    creatAnnotations(diagramId)

    $(document).on('click touch', '.a9s-annotation', function () {

        const shopifyId = $(this).data('shopify-id');

        if(shopifyId){
            var url = 'https://parts.espressoparts.com/shopify-id/' + $(this).data('shopify-id');
            window.open(url, '_blank').focus();
        } else {

            const partName = $(this).data('part_title');
            const diagramName = $(this).data('diagram_name');

            $(".swal2-html-container").html('').html(`
                                <form id="requestPart" method="post" style="margin:0 auto">
                                <div id="pDiagrams" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>Part Request Form</h2>
                                    <h3>${partName}</h3>
                                    
                                    <div style="width:410px;margin:0 auto">
                                        <div style="float: left; text-align: left;margin-right: 10px">
                                            <p><label style="text-align: left;line-height: 0">First Name</label><br><input name='first_name' type="text" class="swal2-input" style="width:200px;margin:5px 0" placeholder="First Name"></p>
                                        </div>
                                        <div style="float: left; text-align: left; margin-bottom: 10px">
                                            <p><label style="text-align: left;line-height: 0">Last Name</label><br><input name='last_name' type="text" class="swal2-input" style="width:200px;margin:5px 0" placeholder="Last Name"></p>
                                        </div>
                                    </div>
                                    
                                    <div style="clear: both;width:410px;margin:0 auto; text-align:left">
                                        <p><label style="text-align: left;line-height: 0">E-Mail Address</label><br><input name='customer_email' type="email" class="swal2-input" style="width:410px;margin:5px 0" placeholder="Email Address"></p>
                                        <p><label style="text-align: left;line-height: 0">Telephone Number (Optional)</label><br><input name='customer_tel' type="tel" class="swal2-input" style="width:410px;margin:5px 0" placeholder="Telephone Number"></p>
                                        <input type="hidden" name="part_name" value="${partName}">
                                        <input type="hidden" name="diagram_name" value="${diagramName}">
                                        <p style="font-weight:bold;color: darkred" id="formError"></p>
                                    </div>    
                                    <button id="formButton" style="background-color: #930" type="submit" class="swal2-confirm swal2-styled" aria-label="" style="display: inline-block;">Request Part</button>
                                    <br>
                                    <br>
                                    
                               </div>
                               </form>
                               `);


            $(document).on('submit', '#requestPart', function (e) {

                e.preventDefault();

                $('input').on('focus', function () {

                    $("#formError").html("");
                })

                $("#formError").html('');
                $("#formButton").hide();

                var values = $(this).serialize();

                $.post(`https://parts.espressoparts.com/api/request-part`,values, function (response) {

                    if(response.error){

                        $("#formError").html(response.error);
                        $("#formButton").show();
                    } else {

                        $(".swal2-html-container").html('').html(`
                                <div id="pDiagrams" class="previous-holder"><span class="previous ">&#8249;</span></div><div class="search-heading">
                                    <h2>Part Request Form</h2>
                                    <h3 style="font-size: 90%; color:red">Thank you, your parts request has been submitted. A customer representative will be in contact regarding pricing and an expected delivery date.</h3>
                               </div>
                               `);

                        $(".previous-holder").empty();
                    }
                });

            });

        }



    })
});

$(document).on("click", '#pParts', function () {

    $(".swal2-html-container").html('').html(diagrams);
});

function creatAnnotations(diagramId) {

    var anno = Annotorious.init({
        image: 'diagram',
        disableSelect: true,
        disableEditor: true,
    });

    anno.loadAnnotations(`https://parts.espressoparts.com/api/diagram/${diagramId}`).then(function (annotation) {

        //Add tooltip if Shopify ID
        $(".a9s-annotation").each(function () {
            var sid = $(this).data('id');
            var result = annotation.find(({id}) => id === sid);

            if (result.shopify_id) {

                var title = result.shopify_title ?? result.supplier_product_title;
                title = title + ` <br> CLICK TO VIEW`

                $(this).attr('data-shopify-id', result.shopify_id);
            } else {

                var title = result.part_title;
                title = title + ` <br> CLICK TO REQUEST PART`

                $(this).attr('data-shopify-id', 0);
                $(this).attr('data-part_title', result.part_title);
                $(this).attr('data-diagram_name', result.diagram_name);
            }

            $(this).attr('title', title).tooltip({
                content: function () {
                    return title;
                }
            });

        });
    });
}


function showLoading() {

    $('.col-search').remove();
    $('.search-heading').remove();
    $('.search-loading').css({'display': 'flex'});
}

function imgError(image) {
    image.onerror = "";
    image.src = "https://parts.espressoparts.com/images/parts/no-image.png";
    return true;
}
